import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import TcoTool from './TcoTool.vue';
import GetManufacturerFromBrand from '../../../used-vue/api/GetManufacturerFromBrand';

Vue.use(Vuex);

const getFirstPaintOption = function (vehicle, paintToExclude = null) {
    if (vehicle === null) {
        return;
    }
    let firstPaintOption = null;
    let secondPaintOption = null;
    vehicle.new_vehicle_paint_options.forEach(paintOption => {
        if (firstPaintOption === null) {
            firstPaintOption = paintOption;
            return;
        }
        if (secondPaintOption === null) {
            secondPaintOption = paintOption;
            return;
        }
    });
    if (firstPaintOption === null) {
        console.error('Vehicle had no paint options', vehicle);
        return null;
    }

    if (paintToExclude === null) {
        return firstPaintOption;
    }

    if (firstPaintOption.id === paintToExclude.id && secondPaintOption === null) {
        return firstPaintOption;
    }

    return secondPaintOption;
};


export default function (tcoElement) {
    const store = new Vuex.Store({
        state: {
            brands: [],
            loadingVehicles: true,
            evModels: [],
            selectedEvModel: null,
            selectedEvTrim: null,
            selectedEvVehicle: null,
            iceModels: [],
            selectedIceModel: null,
            selectedIceTrim: null,
            selectedIceVehicle: null,
            selectedEvPaint: null,
            selectedIcePaint: null,
            evTotalCost: null,
            iceTotalCost: null,
        },
        actions: {
            getBrands({commit}) {
                return new Promise((resolve, reject) => {
                    axios.get('/api/tco-tool/brands').then(response => {
                        const brands = [];
                        response.data.forEach(brand => {
                            if (typeof brand.brand == 'undefined') {
                                console.error('Brand missing', brand);
                                return;
                            }
                            brand.manufacturer = GetManufacturerFromBrand(brand.brand);
                            brands.push(brand);
                        })
                        commit('setBrands', brands);
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error('Error getting TCO brands', error);
                        reject();
                    })
                });
            },
            getVehicles({commit}, brand) {
                return new Promise((resolve, reject) => {
                    axios.get('/api/tco-tool/vehicles', {params: {brand: brand}}).then(response => {
                        const evModels = [];
                        const iceModels = [];
                        response.data.forEach(model => {
                            const newVehicleLength = model.new_vehicles.length;
                            if (newVehicleLength == 0) {
                                console.error("TCO model unexpectedly had no vehicles associated with it", model);
                                return;
                            }
                            let hasEV = false;
                            let hasIce = false;
                            for (let index = 0; index < newVehicleLength; index++) {
                                if (hasEV && hasIce) {
                                    break;
                                }

                                const fuel = model.new_vehicles[index].fuel_type.toLowerCase();
                                if (hasEV == false && (fuel.includes('electric'))) {
                                    hasEV = true;
                                }
                                if (hasIce == false && (fuel.includes('petrol') || fuel.includes('diesel') || fuel.includes('hybrid'))) {
                                    hasIce = true;
                                }
                            }
                            if (hasEV) {
                                // commit('setSelectedEvModel', model);
                                // for (let index = 0; index < model.new_vehicles.length; index++) {
                                //     const vehicle = model.new_vehicles[index];
                                //     const fuel = vehicle.fuel_type.toLowerCase();
                                //     if ((fuel.includes('electric'))) {
                                //         commit('setSelectedEvTrim', vehicle.new_vehicles_trim);
                                //         commit('setSelectedEvVehicle', vehicle);
                                //         break;
                                //     }
                                // }
                                evModels.push(model);
                            }
                            if (hasIce) {
                                // commit('setSelectedIceModel', model);
                                // for (let index = 0; index < model.new_vehicles.length; index++) {
                                //     const vehicle = model.new_vehicles[index];
                                //     const fuel = vehicle.fuel_type.toLowerCase();
                                //     if ((fuel.includes('petrol') || fuel.includes('diesel') || fuel.includes('hybrid'))) {
                                //         commit('setSelectedIceTrim', vehicle.new_vehicles_trim);
                                //         commit('setSelectedIceVehicle', vehicle);
                                //         break;
                                //     }
                                // }
                                iceModels.push(model);
                            }
                        });
                        commit('setEvModels', evModels);
                        commit('setIceModels', iceModels);

                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error('Error getting TCO vehicle data', error);
                        reject();
                    })
                });
            },
        },
        mutations: {
            setBrands(state, brands) {
                state.brands = brands;
            },
            setEvModels(state, evModels) {
                state.evModels = evModels;
            },
            setIceModels(state, iceModels) {
                state.iceModels = iceModels;
            },
            setSelectedEvModel(state, selectedEvModel) {
                state.selectedEvModel = selectedEvModel;
            },
            setSelectedIceModel(state, selectedIceModel) {
                state.selectedIceModel = selectedIceModel;
            },
            setSelectedEvTrim(state, selectedEvTrim) {
                state.selectedEvTrim = selectedEvTrim;
            },
            setSelectedIceTrim(state, selectedIceTrim) {
                state.selectedIceTrim = selectedIceTrim;
            },
            setSelectedEvVehicle(state, selectedEvVehicle) {
                state.selectedEvPaint = getFirstPaintOption(selectedEvVehicle, state.selectedIcePaint);
                state.selectedEvVehicle = selectedEvVehicle;
            },
            setSelectedIceVehicle(state, selectedIceVehicle) {
                state.selectedIcePaint = getFirstPaintOption(selectedIceVehicle, state.selectedEvPaint);
                state.selectedIceVehicle = selectedIceVehicle;
            },
            setSelectedEvPaint(state, selectedEvPaint) {
                state.selectedEvPaint = selectedEvPaint;
            },
            setSelectedIcePaint(state, selectedIcePaint) {
                state.selectedIcePaint = selectedIcePaint;
            },
            setEvTotalCost(state, evTotalCost) {
                state.evTotalCost = evTotalCost;
            },
            setIceTotalCost(state, iceTotalCost) {
                state.iceTotalCost = iceTotalCost;
            },
        }
    })

    return new Vue({
        el: tcoElement,
        store: store,
        components: {
            TcoTool,
        },
    });
}